<template>
  <div class="guide-module">
    <div class="guide-module-item">
      <h3 class="module-title">{{category}} に関する相談をしてみましょう。複数職種のアドバイザーが連携して回答します</h3>
      <span>例えばこんな相談ができます。</span>
      <ul>
        <li>Q. {{counselingTitle1}}</li>
        <li>Q. {{counselingTitle2}}</li>
        <li>Q. {{counselingTitle3}}</li>
      </ul>
    </div>
    <div style="margin:0 0 10px 15px">
      <a :href="adviserLink" target="_blank">
        <img :src="adviserImage" width="64px" style="border-radius:50%">
      </a> <b>{{adviserName}}</b>
    </div>
    <a href="/counselingDetail" v-if="createButton"><button class="footerNavi-button button-primary">相談してみる</button></a>
  </div>
</template>
<script>
import { Common } from './Common.js'
export default {
  props: ['createButton'],
  mixins:[Common],
  data: () => {
    return {
      category: '',
      counselingTitle1: '',
      counselingTitle2: '',
      counselingTitle3: '',
      adviserName: '',
      adviserLink: '',
      adviserImage: '',
    }
  },
  methods: {
    arrayShuffle(array) {
      for(var i = (array.length - 1); 0 < i; i--) {
        // 0〜(i+1)の範囲で値を取得
        var r = Math.floor(Math.random() * (i + 1))

        // 要素の並び替えを実行
        var tmp = array[i]
        array[i] = array[r]
        array[r] = tmp
      }
      return array
    }
  },
  created() {
    //'お金', '就労', '周囲との関係性再構築', '妊孕性', '恋愛・セクシャリティ', 
    // '趣味', '将来設計', '生活', '治療・副作用', 'メンタル'
    
    // 0-9の乱数を生成
    var num = Math.floor(Math.random() * 10)

    var counselingList = []
    if (num === 0) {
      this.category = 'お金'
      counselingList = [
        '抗がん剤治療で休職しています。これからの医療費が不安で仕方ありません。総額どれくらい必要なのでしょうか？',
        '副作用や後遺症によっては、障害年金がもらえると聞きました。どうやって申請すれば良いのですか？ 他にも申請すればもらえるお金はありますか？',
        '傷病手当金がなかなか振り込まれません。どれくらい待てばもらえますか？'
      ]
    } else if (num === 1) {
      this.category = '就労'
      counselingList = [
        '仕事を続けたいので、抗がん剤治療しながら働いています。でも副作用で調子の悪い日もあり、まわりに迷惑をかけていないか不安です。',
        '治療で半年ほど休んでいましたが、来月から復職する予定です。同僚にどのように病気のことを伝えたら良いのか悩んでいます。',
        '3年前に肺がんになりましたが、いまは以前と変わらず働いています。そろそろ転職を考えているのですが、転職活動の際には伝えた方が良いのでしょうか？',
        '中小広告代理店で営業職で働いています。人事には病気のことを伝えたのですが、新しく一緒に働くことになった上司にどこまで伝えるか悩んでいます。',
        '看護師です。一度治療で仕事を辞めましたが、再就職を検討しています。病気のことを言った方がいいですか？',
        '治療が長引いて、休職期間が半年を超えました。会社から退職を促されないか心配です。'
      ]
    } else if (num === 2) {
      this.category = '周囲との関係性再構築'
      counselingList = [
        '治療から2年くらい経ちました。エステや脱毛サロンに行くたび、問診票に「がん」と書くと気を遣われる気がします。正直に言わなくても良いですか？',
        '乳がんになりました。親は高齢で遠方に住んでいるのですが、病気のことを伝えるべきか、伝えたら心配されすぎないか不安です。どのようにコミュニケーションをとると良いでしょうか。',
        '5才の娘がいます。病気のことをどこまで伝えるか、それとも黙っているか悩んでいます。保育園で友だちにからかわれないか心配です。'
      ]
    } else if (num === 3) {
      this.category = '妊孕性'
      counselingList = [
        '治療前に卵子凍結しませんでした。今後妊娠の可能性はどれくらいありますか？',
        '夫が8年前に精巣がんになったそうです。もう治療は終わっていて、今は元気なのですが、わたしたちは子どもを授かれる可能性はありますか？',
        '子どもができた同病の人を見ると羨ましく、子どもができないわたしは悔しくて悲しい気持ちになります。どうやってこの感情と向き合ったら良いのでしょう。',
        '卵巣を摘出済みです。わたしは子どもはいらないと思っていますが、これから付き合う人に、子どもができないことを伝えるのは少し不安です。'        
      ]
    } else if (num === 4) {
      this.category = '恋愛・セクシャリティ'
      counselingList = [
        '抗がん剤で髪が抜けることになりそうです。恋人にはまだ病気のことを言っていません。どう伝えたら良いでしょうか。',
        '手術の後はいつからセックスできますか？ 何か注意する点はありますか？',
        '抗がん剤治療中にセックスしても良いのでしょうか？',
        'お腹に手術の跡があります。いま好きな人には病気のことを言っていません。セックスの前に伝えたいのですが不安で仕方ありません。',
        '性欲が激減してしまいました。何か改善する方法はありますか。'
      ]
    } else if (num === 5) {
      this.category = '趣味'
      counselingList = [
        '飛行機に長時間乗るのが心配です。海外旅行はしても良いでしょうか？',
        '治療のせいか頭がぼーっとすることが多く、運転が不安です。でも車が使えないと生活できません。どうしたら良いでしょうか。',
        'ゴルフが趣味ですが、腕が動かしづらくなりました。改善できますか？',
        'スキューバダイビングに挑戦したいと思っています。問題ないですか？',
        '手術後に人目が気になり、大好きな温泉にいけなくなってしまいました。何か対処法はありますか？',
        '抗がん剤治療や分子標的薬の影響か、爪が薄くなったり、黒ずんだりしています。ジェルネイルをしても大丈夫ですか？',
        '脱毛後、どれくらいで髪は生えてきますか？ カラーやパーマはしても大丈夫ですか？',
        'お酒が大好きです。どれくらい飲んでも良いでしょうか？'
      ]
    } else if (num === 6) {
      this.category = '将来設計'
      counselingList = [
        '家を購入したいと思っています。がん罹患者でもローンは組めるのでしょうか？',
        'いまからでも入れる医療保険はありますか？',
        '3才の息子がいます。夫は忙しいし親は遠方で、治療しながらの育児がしんどいです。'
      ]
    } else if (num === 7) {
      this.category = '生活'
      counselingList = [
        '一人暮らしで治療しています。家の中で倒れたりしないか心配です。',
        '抗がん剤中は食べられるものに制限はありますか？',
        '腕があがらないため洗濯物が干せません。手がしびれて洗濯物が干しにくいのです。どうすれば良いでしょうか？',
        '尿漏れがあるため、パッドが外せない。何か対処法ないでしょうか？',
        'ストーマの排泄物のにおいが気になります。何か対策ありますか？',
        '車酔いがひどくなりました。改善する方法はありますか？'
      ]
    } else if (num === 8) {
      this.category = '治療・副作用'
      counselingList = [
        '大腸がんです。まだ治療の方針は決まっていません。自力排便できなくなる可能性もあるのでしょうか。',
        '最近腰痛が続いています。ただの運動不足なのか再発なのか不安です。すぐに病院に行くべきですか？',
        '口内炎です。抗がん剤治療や放射線療法の副作用なのか、口の中に痛みを感じ始めました。軽減したいのですが、アドバイスはありますか？',
        '免疫チェックポイント阻害薬の影響か、腱鞘炎が出てしまい困っています。昨年度から違和感を感じはじめ、右手が、その後左手も強い腱鞘炎に悩まされるようになってしまいました。主治医に相談したところ、注射を打ってくれたのですが、一時的な気休めにしかならないような感じがします。どうすれば良いでしょうか？',
        'しびれや痛みで外出・運動が困難です。どうすれば良いでしょうか？',
        '抗がん剤の副作用なのか、爪が湾曲し巻き爪となって痛いです。どうすれば良いでしょうか？'
      ]
    } else if (num === 9) {
      this.category = 'メンタル'
      counselingList = [
        'きちんと治療していますが、再発するんじゃないかと不安で仕方ありません。どうしたら緩和できますか。',
        '治療すれば治るとわかっていても、死が怖くて仕方ありません。',
        'わたしの病気を伝えてから母親の様子がおかしい。一緒に心療内科に行った方がいいですか？'
      ]
    }

    var guideAdviser = this.getGuideAdviser(location.hostname)
    this.adviserName = guideAdviser.adviserName
    this.adviserLink = guideAdviser.adviserLink
    this.adviserImage = guideAdviser.adviserImage

    counselingList = this.arrayShuffle(counselingList)
    this.counselingTitle1 = counselingList[0]
    this.counselingTitle2 = counselingList[1]
    this.counselingTitle3 = counselingList[2]
  }
}
</script>
<style>
</style>
